import React, { useEffect, useState } from 'react';
import { getAllBrands, updateManualBrand } from '../services/brandService';
import { Form, Input, Select, Button, message } from 'antd';
import { set } from 'lodash';
const { TextArea } = Input;
const { Option } = Select;

function BatchBrandModification() {
  const [form] = Form.useForm();
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    getAllBrands().then(res => {
      const {data} = res;
      const brandArr = [];
      Object.keys(data).forEach(key => {
        let brand = {};
        brand['name'] = key;
        brand['id'] = data[key];
        brandArr.push(brand);
      })
      setBrands([...brandArr]);
    })
  }, [])

  const onFinish = (value) => {
    const {productIds, brandId} = value;
    let pIdsArr = productIds.split('\n').filter(p => p);
    updateManualBrand({productIds: pIdsArr, brandId}).then(res => {
      console.log(res);
      if(res.data.status === 'ok'){
        message.success('修改成功！')
        form.resetFields();
      } else {
        message.error('修改失败！')
      }
    }).catch(err => {
      console.log(err);
    })
  }
  return (
    <div className='container'>
        <Form
          name="form"
          form={form}
          layout='vertical'
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            label="Products:(每个ID占一行，不允许空行)"
            name="productIds"
            validateFirst
            rules={[
              {
                required: true,
                message: 'Please input productId!',
              },
              { validator: (rules, value, callback) => {
                if(/^\s*$/m.test(value)) return callback('不允许有空行')
                return callback()
              }}
            ]}
          >
            <TextArea allowClear rows={10}/>
          </Form.Item>

          <Form.Item
            label="Brand:"
            name="brandId"
            rules={[
              {
                required: true,
                message: 'Please input your password!',
              }
            ]}
          >
            <Select
              showSearch
              optionFilterProp="children" 
              placeholder="Select a Brand"
            >
              {
                brands && brands.map(item => {
                  return <Option key={item.id} value={item.id}>{item.name} | {item.id}</Option>
                })
              }
            </Select>
          </Form.Item>

          <Form.Item
            style={{textAlign:'right'}}
          >
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Form>
    </div>
  )
}

export default BatchBrandModification